import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { DepartmentModel, DepartmentCreateModel } from 'Pages/departments'
import { serialize } from 'object-to-formdata'
import { FileWithPreview } from 'LibNeo'

export const departmentApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<DepartmentModel>>(urls.department.index, {
			params,
		})
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<DepartmentModel>(`${urls.department.index}/${id}`)
		return res.data
	},
	createOne: async (data: DepartmentCreateModel) => {
		const res = await axiosDS().post<DepartmentModel>(urls.department.index, { data })
		return res.data
	},
	updateOne: async (id: string, data: DepartmentCreateModel) => {
		const res = await axiosDS().patch<DepartmentModel>(`${urls.department.index}/${id}`, { data })
		return res.data
	},
	createMass: async (data: { file: FileWithPreview }) => {
		const res = await axiosDS().post<DepartmentModel>(
			urls.department.mass_create,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
}
